<template>
  <v-dialog
    v-model="state.open"
    width="500"
  >
    <v-card>
      <v-card-title
        class="headline"
        primary-title
      >
        Rediger Kontaktperson
      </v-card-title>

      <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
      <notifications group="dialog" key="dialog" />

      <v-card-text>
        <v-form>
          <v-text-field
            label="Fornavn"
            v-model="state.contact.name"
            required
          ></v-text-field>
          <v-text-field
            label="Etternavn"
            v-model="state.contact.lastname"
            required
          ></v-text-field>
          <v-select
            label="Type"
            :items="types"
            v-model="state.contact.types"
            multiple
            required
          ></v-select>
          <v-text-field
            label="Adresse"
            v-model="state.contact.address"
            required
          ></v-text-field>
          <v-text-field
            label="Mobil"
            v-model="state.contact.phone"
            required
          ></v-text-field>
          <v-text-field
            label="E-post"
            v-model="state.contact.email"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="red"
          dark
          @click="removeContact(state.contact.id)"
        >
          Slett kontaktperson
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-3"
          dark
          @click="state.contact.id ? saveContact(state.contact.id, state.contact) : createContact(state.contact)"
        >
          Lagre endringer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InformationService from '@/services/InformationService'

export default {
  props: ['state'],
  name: 'edit-contact',
  data () {
    return {
      isSubmitting: false,
      types: ['Hovedkontakt', 'Faktura', 'Kontaktperson', 'Web', 'Mail', 'DNS', 'Nyhetsbrev']
    }
  },
  methods: {
    async removeContact (id) {
      const response = await this.runService(this, 'dialog', InformationService.removeContact, id)
      if (response) {
        this.$emit('remove', id)
      }
    },
    async createContact (contact) {
      const response = await this.runService(this, 'dialog', InformationService.createContact, this.state.contact)
      if (response) {
        const contact = response.data
        this.$emit('create', contact)
      }
    },
    async saveContact (id, contact) {
      const response = await this.runService(this, 'dialog', InformationService.saveContact, this.state.contact.id, this.state.contact)
      if (response) {
        const contact = response.data
        this.$emit('save', id, contact)
      }
    }
  }
}
</script>

<style scoped>
</style>
